import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ResolveEnd, ActivatedRouteSnapshot } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';


@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

    private appInsights: ApplicationInsights | null = null;
    private routerSubscription: Subscription;
    buildId: string;
    releaseId: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private meta: Meta
    ) {
        const connString = environment.appInsightsConfig?.connectionString;
        if (connString && !connString.startsWith('#{')) {
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: connString
                }
            });
            this.appInsights.loadAppInsights();
        }

        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof ResolveEnd))
            .subscribe((event: any) => {
                const activatedComponent = this.getActivatedComponent(event.state.root);
                if (activatedComponent) {
                    this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
                }
            });
    }

    setAuthenticatedUserId(userId: string): void {
        if (this.appInsights) {
            this.appInsights.setAuthenticatedUserContext(userId);
        }
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {

        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }

    public logPageView(
        name: string,
        url?: string,
        properties?: { [key: string]: string },
        measurements?: { [key: string]: number },
        duration?: number) {

        if (this.appInsights) {
            this.appInsights.trackPageView({ name, uri: url, properties: this.AddGlobalProperties(properties) });
        }
    }

    public logEvent(name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
        if (this.appInsights) {
            this.appInsights.trackEvent({ name, properties: this.AddGlobalProperties(properties), measurements });
        }
    }

    public logError(error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
        if (this.appInsights) {
            this.appInsights.trackException({ exception: error, properties: this.AddGlobalProperties(properties), measurements });
        }
    }

    private AddGlobalProperties(properties?: { [key: string]: string }): { [key: string]: string } {
      if (!properties) {
          properties = {};
      }

      if(!this.buildId)
      {
        this.buildId = this.meta.getTag('name= "build"').content;
      }

      if(!this.releaseId)
      {
        this.releaseId = this.meta.getTag('name= "release"').content;
      }
      //add your custom properties such as app version
      // properties["environment"] = environment.production ? "prod" : "dev";

      properties["releaseId"] = this.releaseId;
      properties["buildId"] = this.buildId;

      return properties;
     
  }
}
